import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { BaseText } from 'components/common/text'
import { escapeHtml } from 'utils/displays'

const LINE_HEIGHT = 1.6

export const LineLimitedText: React.FC<{
  text: string
  lineClamp?: number
  fontSize?: number
  color?: string
  hasLineBreak?: boolean
  onClick?: () => void
}> = ({ text, lineClamp = 3, fontSize = 15, color, hasLineBreak, onClick }) => {
  const textRef = useRef<HTMLSpanElement>(null)
  const [isShortened, setIsShortened] = useState<boolean | null>(null) // 줄임이 필요할지 아닐지 모르니, 초기값을 null로 줌 => 줄임 필요하면 true => 줄인 걸 더보기하면 false
  const escapedText = escapeHtml(text.trim())

  useEffect(() => {
    setIsShortened(null) // 다른 프로필로 전환되거나 해서 텍스트 내용이 바뀌면 줄임 상태 초기화
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text])

  useEffect(() => {
    if (
      isShortened !== null || // 줄인 적 없는 상태, 즉 초기값인 null일 때만 실행되어야 함
      !textRef.current ||
      text.includes('class=highlighted') // 하이라이팅된 컨텐츠가 포함되어있으면 줄이지 않음
    )
      return
    if (textRef.current.offsetHeight > LINE_HEIGHT * fontSize * lineClamp)
      setIsShortened(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textRef.current?.offsetHeight, fontSize, lineClamp, isShortened])

  return (
    <div
      style={isShortened ? { cursor: 'pointer' } : undefined}
      onClick={(e) => {
        if (isShortened === null || isShortened === false) return
        e.stopPropagation()
        onClick ? onClick() : setIsShortened(!isShortened)
      }}
    >
      <DescText
        ref={textRef}
        isShortened={!!isShortened}
        lineClamp={lineClamp}
        color={color}
        fontSize={fontSize}
        dangerouslySetInnerHTML={{
          __html:
            isShortened && !hasLineBreak
              ? escapedText.replaceAll('\n', ' ')
              : escapedText,
        }}
      />
      {isShortened === true && (
        <MoreTextBtn fontSize={fontSize}>더보기</MoreTextBtn>
      )}
    </div>
  )
}

const DescText = styled(BaseText)<{
  isShortened: boolean
  lineClamp: number
  fontSize: number
  color?: string
}>`
  position: relative;
  display: -webkit-box;
  ${(p) =>
    p.isShortened &&
    `-webkit-box-orient: vertical;
    -webkit-line-clamp: ${p.lineClamp};
    overflow: hidden;
    text-overflow: ellipsis;`}
  word-wrap: break-word;
  line-height: ${LINE_HEIGHT};
  font-size: ${(p) => p.fontSize}px;
  ${(p) => p.color && `color: ${p.color};`}
`

const MoreTextBtn = styled(BaseText)<{ fontSize: number }>`
  white-space: nowrap;
  color: ${(p) => p.theme.color.gray1};
  font-size: ${(p) => p.fontSize}px;
`
